/**
 * Student-facing wording for a protected exam (the SSC Rankers League player and cards): what was
 * blocked, the away warning and the submit notes. Kept local, like the grand-mock copy.
 */
export const EXAM = {
  blocked: {
    copy: 'Copying is turned off during the SSC Rankers League.',
    cut: 'Copying is turned off during the SSC Rankers League.',
    paste: 'Pasting is turned off during the SSC Rankers League.',
    select: 'Selecting text is turned off during the SSC Rankers League.',
    menu: 'Right-click is turned off during the SSC Rankers League.',
    drag: 'Dragging is turned off during the SSC Rankers League.',
    print: 'Printing is blocked in the SSC Rankers League. Screenshots are not allowed.',
    key: 'That shortcut is turned off during the SSC Rankers League.',
  },
  away: 'You left the exam screen. This is recorded. Please stay here until you submit.',
  paused: 'The team has paused the exam. Please wait; you do not lose time. Do not close the app.',
  timeUp: 'Time is up. Submitting your answers…',
  submitting: 'Submitting…',
  oneAttempt: 'One attempt, no pause. Submitting ends your exam.',
} as const;
